import type { ReactNode } from 'react'

import './generalSettings.css'

/**
 * 관리 › 설정 탭 — **«알람 설정» 한 구역**(eric 2026-10-28 「설정 탭 쪽에.. 알람 관련된 설정 화면 만들어줘」).
 *
 * 2026-10-14 에 탭 안의 절을 전부 걷었다(eric 「설정 내용 상세 내용 다 빼고.. 탭에 설정만 남겨.. 여기 다 안 쓸거야」).
 * 걷은 절(컨테이너 파일은 리포에 남아 있고 이 탭이 안 부른다): 운영 모드(`SystemModeContainer`) · 정책 셋
 * (`SettingsPoliciesContainer`) · 시스템 조작(`PrepareModulesContainer`) · 알림 수신자 목록(`AlarmRecipientsContainer`) ·
 * 브로커 계정(`BrokerAccountsContainer`) · 위치 등록부(`PositionRegistryContainer`) · 걸린 것(`StopsContainer`).
 * ⚠ 그 절들은 되살리지 않는다 — 이번에 선 것은 «알람 설정» 하나다. 알림 수신자 목록 절을 같이 꽂지 마라
 *   (같은 수신처를 두 화면이 다르게 고치게 된다).
 *
 * 🔴 **이 파일은 틀만 쥔다 — 내용은 슬롯이다.** `AdminScreen` 이 표시 전용이라 조회 · 구독을 하는 컨테이너
 *    (`AlarmSettingsContainer`)를 직접 부르지 않는다. 슬롯은 `AdminContainer` 가 통합 콘솔에서만 넣는다
 *    (장비 관점 콘솔은 제 탭 목록을 넘기고 슬롯을 받지 않는다 — 그 앱은 고치지 않는다).
 * 🔴 **admin 이 아니면 조회를 쏘지 않는다** — 구역은 서고 사유 한 줄 · 조작은 비활성 + 사유(`roleMatrix.test.tsx` 가 잠근다).
 * ⚠ 옛 주소 `PATHS.adminStops` · `PATHS.adminResourceLocks` 는 이 탭으로 그대로 보낸다(즐겨찾기 · 옛 링크).
 */
export function GeneralSettings({ children }: { children?: ReactNode }) {
  return <div className="gset">{children}</div>
}
